import { render } from "./AppRepairPopups.vue?vue&type=template&id=4450d4bf"
import script from "./AppRepairPopups.vue?vue&type=script&lang=js"
export * from "./AppRepairPopups.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__